

export const ORDER_MAKER_GETTER_WEIGHT_ADJUSTMENT = "ORDER_MAKER_GETTER_WEIGHT_ADJUSTMENT";
export const ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT = "ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT";
export const ORDER_MAKER_ACTION_CLEAR_WEIGHT_ADJUSTMENT = "ORDER_MAKER_ACTION_CLEAR_WEIGHT_ADJUSTMENT";

export default {
    namespaced: true,
    ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT,
    ORDER_MAKER_GETTER_WEIGHT_ADJUSTMENT,
    ORDER_MAKER_ACTION_CLEAR_WEIGHT_ADJUSTMENT
}